import Layout from '@/layout/base/layoutSegfy'

export default [{
    path: '/IndiqueCorretor',
    component: Layout,
    children: [
        {
            path: '',
            component: () => import('@/components/referBroker/referBroker'),
            meta: {
                auth: true
            }
        }
    ]
}]
